import { useQuery } from '@tanstack/react-query';
import { queries } from '../../../../../../shared/queries';

export default function useGetDeviceDetails(params: { id: number }) {
  const { data: deviceDetails } = useQuery({
    ...queries.devices.details({ id: String(params.id) }),
    enabled: !!params.id,
  });

  return { deviceDetails };
}
